import React from 'react';
import PhoneIcon from './icons/PhoneIcon';
import { Tooltip } from './ui/Tooltip';

interface DriverPhoneLinkProps {
  textmsgnumber?: string | null;
  homephone?: string | null;
  size?: number;
}

/**
 * Strips non-numeric characters from a phone number for use in tel: links.
 * Keeps + for international numbers.
 */
const formatPhoneForTel = (phone: string): string => {
  return phone.replace(/[^\d+]/g, '');
};

/**
 * A clickable phone icon that links to a driver's phone number.
 * Uses textmsgnumber if available, falls back to homephone.
 * Shows a disabled gray icon if no phone number is available.
 */
const DriverPhoneLink: React.FC<DriverPhoneLinkProps> = ({
  textmsgnumber,
  homephone,
  size = 18
}) => {
  // Determine which phone number to use
  const phoneNumber = textmsgnumber?.trim() || homephone?.trim() || null;
  const hasPhone = !!phoneNumber;

  if (!hasPhone) {
    // No phone number - show disabled icon
    return (
      <Tooltip placement="bottom" content="No phone number available">
        <span className="inline-flex items-center ml-1.5">
          <PhoneIcon size={size} className="text-gray-300" disabled />
        </span>
      </Tooltip>
    );
  }

  const telHref = `tel:${formatPhoneForTel(phoneNumber)}`;

  return (
    <Tooltip placement="bottom" content={`Call ${phoneNumber}`}>
      <a
        href={telHref}
        className="inline-flex items-center ml-1.5 text-blue-500 hover:text-blue-700 transition-colors"
        onClick={(e) => e.stopPropagation()}
      >
        <PhoneIcon size={size} />
      </a>
    </Tooltip>
  );
};

export default DriverPhoneLink;
